import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5acc4a0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landing" }
const _hoisted_2 = {
  id: "business",
  name: "business",
  class: "section-background-second"
}
const _hoisted_3 = { class: "business" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "主营业务", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "166国际短信平台当前支持发送任何行业，到达成功率90+，专业独立后台，内容自定义+发送状态实时查看", -1))
const _hoisted_6 = { class: "iphone-item" }
const _hoisted_7 = {
  id: "iphone-list",
  class: "iphone-list"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  id: "product",
  name: "product",
  class: "section-background-second"
}
const _hoisted_11 = { class: "product" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "产品优势", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description" }, "166专业短信群发平台，国际通道，100%实发，出现波动失败会返还相对应的条数， 24小时客服在线处理问题，给您带来省钱，省心，省时等诸多优势", -1))
const _hoisted_14 = { class: "product-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_back_to_top = _resolveComponent("back-to-top")!
  const _component_background_section = _resolveComponent("background-section")!
  const _component_product_advantages = _resolveComponent("product-advantages")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_back_to_top),
    _createVNode(_component_background_section, {
      titleEn: "166 INTERNATIONAL GROUP MESSAGING PLATFORM",
      titleCn: "166国际短信群发平台",
      description: "好用但不贵！优质国际通道，24小时发送不限量！",
      textBtn: "点击立即联系 赠送免费体验短信",
      path: "/contact-us"
    }),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iphoneList, (iphone, index) => {
              return (_openBlock(), _createElementBlock("img", {
                src: iphone,
                key: index
              }, null, 8, _hoisted_8))
            }), 128))
          ]),
          _createElementVNode("img", {
            src: _ctx.iphoneBackgroundImage,
            alt: "background image",
            class: "background-circle"
          }, null, 8, _hoisted_9)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productList, (item, index) => {
            return (_openBlock(), _createBlock(_component_product_advantages, {
              src: item.img,
              title: item.title,
              content: item.content,
              key: index
            }, null, 8, ["src", "title", "content"]))
          }), 128))
        ])
      ])
    ])
  ]))
}